// @flow
import * as types from './types';


export function transformTripToRequestData(trip: types.Category) {
  return {
    id: trip.id,
    clientId: trip.clientId,
    isDeleted: trip.isDeleted,
    modifiedAt: trip.modifiedAt,

    vehicleId: trip.vehicleId,
    startTripOn: trip.startTripOn,
    endTripOn: trip.endTripOn,
    purpose: trip.purpose,
    type: trip.type,
    startLocation: trip.startLocation,
    endLocation: trip.endLocation,
    odometerStart: trip.odometerStart,
    odometerEnd: trip.odometerEnd,
    distance: Number(trip.distance),
    otherCosts: trip.otherCosts,

  };
}

export function transformResponseToTrips(response: any) {
  return response.data.resources.map((data) => (
    types.mkTrip({
      id: data.id,
      clientId: data.clientId,
      isDeleted: data.isDeleted,
      modifiedAt: data.modifiedAt,

      vehicleId: data.vehicleId,
      startTripOn: data.startTripOn,
      endTripOn: data.endTripOn,
      purpose: data.purpose,
      type: data.type,
      startLocation: data.startLocation,
      endLocation: data.endLocation,
      odometerStart: data.odometerStart,
      odometerEnd: data.odometerEnd,
      distance: Number(data.distance),
      otherCosts: data.otherCosts,
    })
  ));
}

